export default __webpack_public_path__ + "static/media/portfolio-hover-193.6f2442f2.jpg";